export const STREET_TYPES: string[] = [
  'rue',
  'avenue',
  'av',
  'bd',
  'boulevard',
  'chemin',
  'ch',
  'impasse',
  'allée',
  'allee',
  'route',
  'rt',
  'quai',
  'place',
  'pl',
  'cours',
  'cr',
  'passage',
  'sentier',
]
